module.exports = __webpack_public_path__ + "13dff2a1c10c6c6baadb18da6886dd78.pdf";